/**
 * @packageDocumentation
 * @module dom/is
 */

import is_node from './is_node';

export interface IsTag {
  /**
   * Is this element's tag name the same as the tag name provided?
   * @param tagName the tag name we are verifying
   * @param node a tag
   * @return true if Node, false otherwise
   */
  <E extends Element | Node>(tagName: string, node: E): node is E;
}

/**
 * { @link IsTag }
 */
export default <E extends Element | Node>(tagName: string, node: E): node is E =>
  is_node(node) && node['nodeName'].toLowerCase() === tagName.toLowerCase();
